import { EditableCourse, CourseSummary } from "features/course/types";
import { scaffoldEdit } from "../../../common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "COURSE/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "COURSE/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "COURSE/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "COURSE/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "COURSE/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "COURSE/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableCourse, CourseSummary, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };
